import {
    getBoarWeights,
    getOtherWeights,
    getSowWeights,
} from "../../utils/SettingsUtils";
import moment from "moment";
import {localMomentToUTC} from "../../utils/DateTimeUtils";
import AnimalTypes from "@wesstron/utils/Api/constants/animalTypes";

export default class EstimatedWeight {
    constructor(
        birthTimestamp = Date.now(),
        weights = getOtherWeights(),
        animalKind
    ) {
        this.weightTable = this.getWeightTable(animalKind, weights);
        this.birthDate = localMomentToUTC(birthTimestamp).startOf("day");
    }

    getWeightsForAnimalKind(type) {
        switch (type) {
            case AnimalTypes.SOW:
                return getSowWeights();
            case AnimalTypes.BOAR:
                return getBoarWeights();
            default:
                return getOtherWeights();
        }
    }

    getWeightTable(type, weights) {
        return [1200, ...this.getWeights(type, weights)];
    }

    getWeights(type, weights) {
        if (weights.length) return weights;
        return this.getWeightsForAnimalKind(type);
    }

    setBirtDateByInsertionDateAndPigAge(insertionDateUTC, animalAgeInDays) {
        this.birthDate = moment
            .utc(insertionDateUTC)
            .startOf("day")
            .subtract(animalAgeInDays, "days");
        return this;
    }

    setWeightTable(weightTable, startingWeight = null) {
        this.weightTable =
            startingWeight === null
                ? [weightTable[0], ...weightTable]
                : [startingWeight, ...weightTable];
        return this;
    }

    setBirthDate(birthTimestamp) {
        this.birthDate = localMomentToUTC(birthTimestamp).startOf("day");
        return this;
    }

    getWeightByDate(timestamp) {
        const evaluatingDay = localMomentToUTC(timestamp).startOf("day");
        const age = evaluatingDay.diff(this.birthDate, "days");
        return this.getWeightByAge(age);
    }

    getGainByDate(timestamp) {
        const evaluatingDay = localMomentToUTC(timestamp).startOf("day");
        const age = evaluatingDay.diff(this.birthDate, "days");
        return this.getGainByAge(age);
    }

    _getWeightByWeekIndex(weekIndex) {
        const weightStart =
            this.weightTable[weekIndex] ??
            this.weightTable[this.weightTable.length - 1];
        const weightEnd =
            this.weightTable[weekIndex + 1] ??
            this.weightTable[this.weightTable.length - 1];
        return [weightStart, weightEnd];
    }

    _getSingleDayGainByWeekIndex(weekIndex) {
        const [weightStart, weightEnd] = this._getWeightByWeekIndex(weekIndex);
        const diff = weightEnd - weightStart;
        return diff / 7;
    }

    /**
     * liczenie przyrostu w fancy sposób, który bierzę pod uwagę przyrost w następnym i poprzednim tygodniu
     * chodzi o to, żeby przez X dni przyrost nie był stały, lecz aby się zbliżał do przyrostu w następnym tygodniu
     * @param ageAsDays
     * @return {number}
     */
    getGainByAge(ageAsDays = 0) {
        const currentWeekIndex = Math.floor(ageAsDays / 7);
        const dayIndex = ageAsDays % 7;

        const currentGain = this._getSingleDayGainByWeekIndex(currentWeekIndex);
        const nextGain = this._getSingleDayGainByWeekIndex(
            currentWeekIndex + 1
        );
        const prevGain = this._getSingleDayGainByWeekIndex(
            currentWeekIndex - 1
        );

        const nextStep = (nextGain - currentGain) / 7;
        const prevStep = (prevGain - currentGain) / 7;

        const max = dayIndex * nextStep + currentGain;
        const min = (6 - dayIndex) * prevStep + currentGain;

        const baseGain = (max + min) / 2;

        return Math.round(baseGain / 5) * 5;
    }

    getWeightByAge(ageAsDays = 0) {
        if (ageAsDays < 0) return null;
        const weekIndex = Math.floor(ageAsDays / 7);
        const index = ageAsDays % 7;

        const [weightStart, weightEnd] = this._getWeightByWeekIndex(weekIndex);

        const step = (weightEnd - weightStart) / 7;
        return Math.round(index * step + weightStart);
    }
}
